import axios from 'axios';
import config from 'api/urls-config.json';

export const getHomepage = params => {
    return axios.get(`${config.API + config.pages.homepage}`, { params });
};
